export default __webpack_public_path__ + "static/GT-America-Mono-Regular-Italic-793e177eff3b1d2cd06d3c84b47761c5.woff";